import BaseApi from '../../base/base'
import ExamGenerationForm from '../../../forms/exam_generation'
import ExamGeneration from '../../../models/exam_generation'

export default class ExamGenerationApi extends BaseApi {
  constructor() {
    super()
  }

  async get(examId, params = {}) {
    this.path = `/admin/exams/${examId}/exam_generations`
    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new ExamGeneration(element)
    })
  }

  async post(examId, params: ExamGenerationForm) {
    this.path = `/admin/exams/${examId}/exam_generations`
    const response = await this.postRequest(params)
    return response
  }
}
